<template>
    <div id="chart-container" :class="this.state.control_size" v-if="this.state.graph_mode == 'graphics'">
        <div id="chart-inner-container">
            <div class="anim-cont">
                <div class="nyan" :class="{'show': state.nyan}">
                    <img src="/bustabit/img/nyan.gif">
                </div>
            </div>
            <div class="max-profit">
                <strong><span>{{$trans('label.Max profit')}}: </span></strong>
                <span>{{utils.comma(this.state.max_profit)}}</span>
                <span>{{state.currency ? state.currency.toLowerCase() : ''}}</span>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        name: "graphic-display",
        props: ['state'],
        data: function() {
            return {
                utils: utils,
            };
        },
        created()
        {
            // console.log('graphic display created.');
            this.onWindowResizeBinded = this.onWindowResize.bind(this);
            this.onChangeBinded = this.onChange.bind(this);

            EventBus.$on('start_rendering', this.startRendering);
            EventBus.$on('stop_rendering', this.stopRendering);
        },
        beforeDestroy()
        {
            EventBus.$off('start_rendering', this.startRendering);
            EventBus.$off('stop_rendering', this.stopRendering);
            this.stopRendering();
        },
        mounted()
        {
            // console.log('graphic display mounted.');
            EventBus.$emit('push_component', 'graphic-display');
        },
        updated()
        {
            if (this.state.graph_mode === 'graphics') {
                this.startRendering();
            }
        },
        methods: {
            onWindowResize()
            {
                this.canvasWidth = this.chart_inner_container.clientWidth;
                this.canvasHeight = this.chart_inner_container.clientHeight;
                this.configPlotSettings();
            },
            onChange()
            {
                this.theme = this.$cookie.get('_b') ? 'black' : 'white';
                this.configPlotSettings();
            },
            startRendering()
            {
                // console.log('graphic display startRendering');
                this.state.rendering = true;

                if ($('#chart-inner-container canvas').length > 0) {
                    $('canvas').remove();
                }
                this.chart_inner_container = $('#chart-inner-container')[0];
                $('#chart-inner-container').append('<canvas>');

                if (this.state.graph_mode === 'text') {
                    $('canvas').addClass('hide');
                }

                this.canvas = $('canvas')[0];
                this.ctx = this.canvas.getContext('2d');

                this.canvasWidth = this.chart_inner_container.clientWidth;
                this.canvasHeight = this.chart_inner_container.clientHeight;

                this.configPlotSettings();

                this.animRequest = window.requestAnimationFrame(this.render.bind(this));

                window.addEventListener('resize', this.onWindowResizeBinded);
            },
            stopRendering()
            {
                // console.log('graphic display stopRendering');
                this.state.rendering = false;
                window.removeEventListener('resize', this.onWindowResizeBinded);

                if (window.cancelAnimationFrame) {
                    window.cancelAnimationFrame(this.animRequest);
                }

            },
            render()
            {
                // console.log('Render rendering : ', this.state.rendering)
                if (!this.state.rendering) {
                    return;
                }
                this.calGameData();
                if (this.currentGamePayout != Infinity) {
                    this.calculatePlotValues();
                    this.clean();
                    this.drawGraph();
                    this.drawAxes();
                    this.drawGameData();
                }
                this.animRequest = window.requestAnimationFrame(this.render.bind(this));
            },
            configPlotSettings()
            {
                this.canvas.width = this.canvasWidth;
                this.canvas.height = this.canvasHeight;
                this.plotWidth = this.canvasWidth - 30;
                this.plotHeight = this.canvasHeight - 20; //280
                this.xStart = this.canvasWidth - this.plotWidth;
                this.yStart = this.canvasHeight - this.plotHeight;
                this.XAxisPlotMinValue = 10000;    //10 Seconds
                this.YAxisSizeMultiplier = 2;    //YAxis is x times
                this.YAxisInitialPlotValue = "zero"; //"zero", "betSize" //TODO: ???
                // console.log('this.canvasWidth : ', this.canvasWidth)
            },
            calGameData()
            {
                this.currentTime = window.Clib.getElapsedTimeWithLag(this.state);
                // console.log('this.currentTime', this.currentTime)
                this.currentGamePayout = window.Clib.calcGamePayout(this.currentTime);
                this.state.game_at = parseFloat(this.currentGamePayout).toFixed(2);
                // console.log('parseFloat(this.currentGamePayout).toFixed(2)', parseFloat(this.currentGamePayout).toFixed(2))
                // console.log('calGameData', this.currentTime, this.currentGamePayout)
            },
            calculatePlotValues()
            {
                // console.log('///////////// calculatePlotValues')
                // Plot variables
                this.YAxisPlotMinValue = this.YAxisSizeMultiplier;
                this.YAxisPlotValue = this.YAxisPlotMinValue;

                this.XAxisPlotValue = this.XAxisPlotMinValue;

                // Adjust X Plot's Axis
                if(this.currentTime > this.XAxisPlotMinValue)
                    this.XAxisPlotValue = this.currentTime;

                // Adjust Y Plot's Axis
                if(this.currentGamePayout > this.YAxisPlotMinValue)
                    this.YAxisPlotValue = this.currentGamePayout;

                // We start counting from cero to plot
                this.YAxisPlotValue-=1;

                // Graph values
                this.widthIncrement = this.plotWidth / this.XAxisPlotValue;
                this.heightIncrement = this.plotHeight / (this.YAxisPlotValue);
                this.currentX = this.currentTime * this.widthIncrement;
            },
            clean()
            {
                // console.log('///////////// clean : ', this.canvas.width, this.canvas.height);
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            },
            drawGraph()
            {
                // console.log('///////////// drawGraph')
                /* Style the line depending on the game states */
                this.ctx.strokeStyle = (this.state.theme == 'white' ? "Black" : "#b0b3c1");

                // Playing and not cashed out
                if (window.StateLib.currentlyPlaying(this.state)) {
                    this.ctx.lineWidth = 6;
                    this.ctx.strokeStyle = '#7cba00';

                    // Cashing out
                } else if(this.state.cashing_out) {
                    this.ctx.lineWidth = 6;
                    // this.ctx.strokeStyle = "Grey";

                } else {
                    this.ctx.lineWidth = 4;
                }

                this.ctx.beginPath();
                window.Clib.seed(1);

                /* Draw the graph */
                // console.log('this.currentTime', this.currentTime)
                for (let t = 0, i = 0; t <= this.currentTime; t += 100, i++) {

                    /* Graph */
                    let payout = window.Clib.calcGamePayout(t) - 1; // We start counting from one x
                    let y = this.plotHeight - (payout * this.heightIncrement);
                    let x = t * this.widthIncrement;
                    this.ctx.lineTo(x + this.xStart, y);

                    /* Draw green line if last game won */ //TODO: Avoid doing the code above this if it will do this
                    /*var realPayout = window.Clib.payout(this.betSize, t);
                     if(this.lastGameWon && (window.Clib.payout(this.betSize, t) > this.lastWinnings) && !greenSetted) {
                     var tempStroke = this.ctx.strokeStyle;
                     this.ctx.strokeStyle = '#7cba00';
                     this.ctx.stroke();

                     this.ctx.beginPath();
                     this.ctx.lineWidth=3;
                     this.ctx.moveTo(x + this.xStart, y);
                     this.ctx.strokeStyle = tempStroke;
                     greenSetted = true;
                     }*/

                    /* Avoid crashing the explorer if the cycle is infinite */
                    if (i > 5000) {
                        console.log("For 1 too long!");
                        break;
                    }
                }
                this.ctx.stroke();
            },
            drawAxes()
            {
                // console.log('///////////// drawAxes')
                // Function to calculate the plotting values of the Axes
                function stepValues(x) {
                    console.assert(_.isFinite(x));
                    let c = .4;
                    let r = .1;
                    while (true) {

                        if (x <  c) return r;

                        c *= 5;
                        r *= 2;

                        if (x <  c) return r;
                        c *= 2;
                        r *= 5;
                    }
                }

                // Calculate Y Axis
                this.YAxisPlotMaxValue = this.YAxisPlotMinValue;
                this.payoutSeparation = stepValues(!this.currentGamePayout ? 1 : this.currentGamePayout);

                this.ctx.lineWidth = 1;
                this.ctx.strokeStyle = (this.state.theme == 'white' ? "Black" : "#b0b3c1");
                this.ctx.font = "10px Verdana";
                this.ctx.fillStyle = (this.state.theme == 'white' ? 'black' : "#b0b3c1");
                this.ctx.textAlign = "center";

                // Draw Y Axis Values
                let heightIncrement =  this.plotHeight / (this.YAxisPlotValue);
                for (let payout = this.payoutSeparation, i = 0; payout < this.YAxisPlotValue; payout+= this.payoutSeparation, i++) {
                    let y = this.plotHeight - (payout*heightIncrement);
                    this.ctx.fillText((payout + 1) +'x', 10, y);

                    this.ctx.beginPath();
                    this.ctx.moveTo(this.xStart, y);
                    this.ctx.lineTo(this.xStart + 5, y);
                    this.ctx.stroke();

                    if (i > 100) {
                        console.log("For 3 too long");
                        break;
                    }
                }

                // Calculate X Axis
                this.milisecondsSeparation = stepValues(this.XAxisPlotValue);
                this.XAxisValuesSeparation = this.plotWidth / (this.XAxisPlotValue/this.milisecondsSeparation);

                //Draw X Axis Values
                for (let miliseconds = 0, counter = 0, i = 0; miliseconds < this.XAxisPlotValue; miliseconds += this.milisecondsSeparation, counter++, i++) {
                    let seconds = miliseconds / 1000;
                    let textWidth = this.ctx.measureText(seconds).width;
                    let x = (counter * this.XAxisValuesSeparation) + this.xStart;
                    this.ctx.fillText(seconds, x - textWidth/2, this.plotHeight + 11);

                    if (i > 100) {
                        console.log("For 4 too long");
                        break;
                    }
                }

                // Draw background Axis
                this.ctx.lineWidth = 1;
                this.ctx.beginPath();
                this.ctx.moveTo(this.xStart, 0);
                this.ctx.lineTo(this.xStart, this.canvasHeight - this.yStart);
                this.ctx.lineTo(this.canvasWidth, this.canvasHeight - this.yStart);
                this.ctx.stroke();
            },
            drawGameData()
            {
                // console.log('///////////// drawGameData')
                // One percent of canvas width
                let onePercent = this.canvasWidth / 100;

                // Multiply it x times
                function fontSizeNum(times) {
                    return onePercent * times;
                }
                // Return the font size in pixels of one percent of the width canvas by x times
                function fontSizePx(times) {
                    let fontSize = fontSizeNum(times);
                    return fontSize.toFixed(2) + 'px';
                }

                this.ctx.textAlign = "center";
                this.ctx.textBaseline = 'middle';

                if (this.state.game_state === 'IN_PROGRESS') {

                    // console.log('window.StateLib.currentlyPlaying(this.state)', window.StateLib.currentlyPlaying(this.state))
                    if (window.StateLib.currentlyPlaying(this.state)) {
                        this.ctx.fillStyle = '#7cba00';
                    } else {
                        this.ctx.fillStyle = (this.state.theme == 'white' ? "black" : "#b0b3c1");
                    }

                    this.ctx.font = fontSizePx(20) + " Verdana";
                    this.ctx.fillText(parseFloat(this.currentGamePayout).toFixed(2) + 'x', this.canvasWidth / 2, this.canvasHeight / 2);
                }

                //If the engine enters in the room @ ENDED it doesn't have the crash value, so we don't display it
                if (this.state.game_state === 'ENDED') {
                    this.ctx.font = fontSizePx(10) + " Verdana";
                    this.ctx.fillStyle = "red";
                    this.ctx.fillText(this.$trans('label.Busted'), this.canvasWidth / 2, this.canvasHeight / 2 - fontSizeNum(10) / 2);
                    this.ctx.fillText('@ ' + window.Clib.formatDecimals(this.state.game_history[0].game_crash/100, 2) + 'x', this.canvasWidth/2, this.canvasHeight/2 + fontSizeNum(10) / 2);
                }

                if (this.state.game_state === 'STARTING') {
                    this.ctx.font = fontSizePx(4) + " Verdana";
                    this.ctx.fillStyle = "grey";

                    // console.log('this.state.start_time', this.state.start_time)
                    let timeLeft = ((this.state.start_time - Date.now()) / 1000).toFixed(1);

                    this.ctx.fillText(`${this.$trans('label.Next round in')} `+ timeLeft +'s', this.canvasWidth / 2, this.canvasHeight / 2);
                }

                //if(this.lag) {
                //    this.ctx.fillStyle = "black";
                //    this.ctx.font="20px Verdana";
                //    this.ctx.fillText('Network Lag', 250, 250);
                //}
            },
        }
    }
</script>

<style scoped>

</style>
